var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{style:(_vm.gridContainerStyle)},_vm._l((_vm.images),function(image,index){return _c('div',{key:index},[_c('imageDetail',{attrs:{"src":image.key,"indexInArray":image.index,"array":_vm.images}})],1)}),0)}
var staticRenderFns = []

export { render, staticRenderFns }